import React, { Fragment } from "react";
import './titlebar-slider-item.css'

const TitleSliderItem = (props) => {
  const textColor = props.collapsedDrawerTextColor
  const description = props.description
  return (
    <div className="drawerTitleTextWrapper">
        <p className="drawerTitleText" style={{color: `${textColor}`}}>{description}</p>
    </div>
  );
};

export default React.memo(TitleSliderItem);
